import { render } from "./Figure.vue?vue&type=template&id=03e39680&bindings={\"alt\":\"data\",\"name\":\"props\",\"desc\":\"props\",\"appearance\":\"props\"}"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"

import "./Figure.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script